"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateVehicle = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const StateVehicles_1 = require("./StateVehicles");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
class StateVehicle extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageVehicle, "Vehicle", true);
        this.page.ctrls.btnSave.onclick = () => this.trySave();
        this.page.ctrls.btnDelete.onclick = () => this.tryDelete();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (args) {
                if (args instanceof models_1.Vehicle)
                    this._vehicle = args;
                else if (args.id) {
                    this._vehicle = yield this.lockgui(this.app.api.admin.directory.getVehicle(args.id));
                    if (!this._vehicle)
                        return gs_1.StateRunResultEnum.Failed;
                }
            }
            if (this._vehicle)
                this._urlArgs["id"] = this._vehicle.id.toString();
            yield this.fill();
            return _super.start.call(this);
        });
    }
    fill() {
        return __awaiter(this, void 0, void 0, function* () {
            const ctrl = this.page.ctrls;
            ctrl.btnDelete.show();
            if (this._vehicle) {
                yield ctrl.form.fillFormData(this._vehicle, true);
                this._setIsDeletedControl(Boolean(this._vehicle.isDeleted));
                ctrl.chIsDeleted.el.disabled = false;
                this._updateDeleteButton();
                const vt = yield this.app.astra.getVehiclesType(this._vehicle.vehicleTypeId);
                const btn = gs.html.tag("button", { class: `${gs_1.ItemButton.TagClassName} no-active selected` }, gs.text.clearHtmlToText(this._formatVehicleTypeLabel(vt)));
                ctrl.rbType.append(btn);
                ctrl.iGovNumber.addClass("no-active");
                ctrl.iModel.addClass("no-active");
                ctrl.iColor.addClass("no-active");
            }
            else {
                ctrl.btnDelete.hide();
                this._setIsDeletedControl(false);
                ctrl.chIsDeleted.el.disabled = true;
                const types = yield this.app.astra.getVehiclesTypes();
                if (types)
                    for (const vt of types) {
                        const btn = gs.w(gs.html.tag("button", { class: `${gs_1.ItemButton.TagClassName}` }, gs.text.clearHtmlToText(this._formatVehicleTypeLabel(vt))));
                        btn.setData(gs_1.ItemButton.TagDataValue, vt.id.toString());
                        ctrl.rbType.append(btn);
                    }
                this._updateDeleteButton();
            }
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            if (this._vehicle)
                this.setLabel(this.title + ` #${this._vehicle.id} ${this._vehicle.govNumber}`);
        });
    }
    trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            let vehicle;
            const isDeleted = this._getIsDeletedValue();
            if (this._vehicle) {
                const req = new models_1.CreateVehicleRequest(data);
                if (!req.typeId)
                    req.typeId = this._vehicle.vehicleTypeId;
                if (!req.govNumber)
                    req.govNumber = this._vehicle.govNumber;
                if (!req.model)
                    req.model = this._vehicle.model;
                if (!req.color)
                    req.color = this._vehicle.color;
                if (!req.vehicleData)
                    req.vehicleData = this._vehicle.vehicleData;
                req.isDeleted = isDeleted;
                vehicle = yield this.lockgui(this.app.api.admin.directory.updateVehicle(this._vehicle.id, req));
                if (!vehicle)
                    return;
                yield new modalCom.DialogOk("Vehicle updated").show();
                this._vehicle = vehicle;
                this._setIsDeletedControl(Boolean(vehicle.isDeleted));
                this._updateDeleteButton();
            }
            else {
                const req = new models_1.CreateVehicleRequest(data);
                req.typeId = parseInt(this.page.ctrls.rbType.value);
                if (!req.typeId) {
                    yield new modalCom.DialogOk("Need select vehicles type").show();
                    return;
                }
                req.isDeleted = isDeleted;
                vehicle = yield this.lockgui(this.app.api.admin.directory.createVehicle(req));
                if (!vehicle)
                    return;
                yield new modalCom.DialogOk("Vehicle created").show();
                yield gs_1.StateGS.Run(StateVehicles_1.StateVehicles);
            }
        });
    }
    _getIsDeletedValue() {
        return Boolean(this.page.ctrls.chIsDeleted.el.checked);
    }
    _setIsDeletedControl(value) {
        this.page.ctrls.chIsDeleted.el.checked = value;
        this.page.ctrls.chIsDeleted.el.value = value ? "true" : "false";
    }
    tryDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._vehicle)
                return;
            if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.VehicleControl))
                return;
            if (!this._vehicle.isDeleted) {
                const response = yield this.lockgui(this.app.api.admin.directory.deleteVehicle(this._vehicle.id));
                if (!response)
                    return;
                this._vehicle.isDeleted = true;
                this._setIsDeletedControl(true);
                this._updateDeleteButton();
                yield new modalCom.DialogOk("Vehicle deleted").show();
                return;
            }
            const restored = yield this.lockgui(this.app.api.admin.directory.restoreVehicle(this._vehicle.id));
            if (!restored)
                return;
            this._vehicle = restored;
            yield this.page.ctrls.form.fillFormData(this._vehicle, true);
            this._setIsDeletedControl(Boolean(this._vehicle.isDeleted));
            this._updateDeleteButton();
            yield new modalCom.DialogOk("Vehicle restored").show();
        });
    }
    _updateDeleteButton() {
        const btn = this.page.ctrls.btnDelete;
        if (!btn)
            return;
        if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.VehicleControl) ||
            !this._vehicle) {
            btn.hide();
            return;
        }
        const isDeleted = Boolean(this._vehicle.isDeleted);
        btn.el.title = isDeleted ? "Restore vehicle" : "Delete vehicle";
        btn.show();
    }
    _formatVehicleTypeLabel(vtype) {
        if (!vtype)
            return "Vehicle type";
        const parts = [];
        if (vtype.sizeClass)
            parts.push(vtype.sizeClass);
        if (vtype.size)
            parts.push(`w${vtype.size.width} : l${vtype.size.length} : h${vtype.size.height}`);
        const summary = parts.filter(Boolean).join(" | ");
        return summary || `#${vtype.id}`;
    }
}
exports.StateVehicle = StateVehicle;
StateVehicle.StateName = "vehicle";
//# sourceMappingURL=StateVehicle.js.map